import { useId, useState, type ReactNode } from "react";

export interface PanelProps {
  title: string;
  children: ReactNode;
  defaultOpen?: boolean;
  /** Rendered next to the title, e.g. a status summary. */
  summary?: ReactNode;
}

/** Collapsible section. Detail panels default to closed to keep the main screen calm. */
export function Panel({ title, children, defaultOpen = false, summary }: PanelProps) {
  const [open, setOpen] = useState(defaultOpen);
  const id = useId();

  return (
    <section className="panel" aria-labelledby={`${id}-title`}>
      <div className="panel__header">
        <button
          type="button"
          className="panel__toggle"
          aria-expanded={open}
          aria-controls={`${id}-body`}
          onClick={() => {
            setOpen((prev) => !prev);
          }}
        >
          <span aria-hidden="true">{open ? "▾" : "▸"}</span>
          <span id={`${id}-title`}>{title}</span>
        </button>
        {summary !== undefined && <div className="panel__summary">{summary}</div>}
      </div>
      <div id={`${id}-body`} className="panel__body" hidden={!open}>
        {children}
      </div>
    </section>
  );
}
